import Component from '../core/Component'

export default class DocumentLayout extends Component {
    constructor(element, options = {}) {
        super(element, options)

    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)

        this.updateCount()
    }

    handleChange = (event) => {
        const groupEl = event.target.closest('[data-group]')

        this.updateGroupEl(groupEl)
        this.updateCount()
    }

    updateGroupEl(groupEl) {
        if (!groupEl) {
            return
        }

        const inputEls = [...groupEl.querySelectorAll('input')]
        const labelEl = inputEls.find(inputEl => inputEl.checked)?.closest('label')
        if (!labelEl) {
            return
        }

        const valueEl = groupEl.querySelector('[data-value]')
        if (!valueEl) {
            return
        }
        valueEl.innerHTML = labelEl.innerText

        const toggleBlockEl = groupEl.querySelector('[data-component="ToggleBlock"]')
        if (!toggleBlockEl) {
            return
        }

        const toggleBlock = Component.getFromElement(toggleBlockEl)
        if (!toggleBlock) {
            return
        }

        toggleBlock.close()
    }

    updateCount() {
        const countSourceEl = this.element.querySelector('[data-count-source')
        if (!countSourceEl) {
            return
        }

        const countEl = this.element.querySelector('[data-count]')
        if (!countEl) {
            return
        }

        countEl.innerHTML = countSourceEl.innerHTML
    }
}